module.exports = __webpack_public_path__ + "img/chord-label-C.b407ea45.png";